export default __webpack_public_path__ + "static/media/elbow2.e99a4b6d.png";